// extracted by mini-css-extract-plugin
export default {"layout":"main-layout_layout__YJyMe","layoutContent":"main-layout_layoutContent__ebqP2","mainMenuContainer":"main-layout_mainMenuContainer__gZgNI"};